export default __webpack_public_path__ + "static/media/martini-logo.11cf01f0.png";